import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import _ from "lodash";
import "./assets/styles/index.css";
import browserDetect from "vue-browser-detect-plugin";
import vuescroll from "vue-scroll";
import Carousel3d from "vue-carousel-3d";
import VueTouchKeyboard from "vue-touch-keyboard";
import "./assets/styles/keyboard.css";
import VModal from "vue-js-modal";
import VueCookies from "vue-cookies";
import VueCrypt from "vue-crypt";
import dotenv from 'dotenv';

import "../node_modules/@glidejs/glide/dist/css/glide.core.css";

Vue.config.productionTip = false;

dotenv.config();

/** Defining Loadash as Global Property. Will be accessible in template */
Object.defineProperty(Vue.prototype, "$_", { value: _ });
window.$eventBus = new Vue();

import Picture from "./components/Picture.vue";

import { layouts } from "./utils/vendors/touch-keyboard.vue";
import { pricify ,styles } from "./utils";

Vue.use(VModal, { dialog: true });
Vue.use(VueCookies);
Vue.use(VueCrypt);
Vue.use(browserDetect);
Vue.use(vuescroll);
Vue.use(Carousel3d);
Vue.use(VueTouchKeyboard, {
  options: {
    useKbEvents: false,
    preventClickEvent: false,
  },
  layout: layouts.kiosk,
});

Vue.component("Picture", Picture);
// Vue.component('vue-touch-keyboard', {
//   extend: VueTouchKeyboard,
//   props: {
//     options: {
//       type: Object,
//       default() {
//         return {
//           useKbEvents: false,
//           preventClickEvent: false
//         }
//       }
//     },
//     layout: {
//       type: Object,
//       default() {
//         return layouts.kiosk
//       }
//     }
//   }
// })

Vue.mixin({
  methods: {
    pricify,
    makeStyles:styles
  },
});

new Vue({
  router,
  store,
  languageLocales: {
    de: {
      locale: "de-DE",
      currency: "EUR",
    },
    nl: {
      locale: "nl-NL",
      currency: "EUR",
    },
    fr: {
      locale: "fr-FR",
      currency: "EUR",
    },
    en: {
      locale: "en-US",
      currency: "EUR",
    },
  },
  render: (h) => h(App),
}).$mount("#app");

/**
 * Directive for translations.
 */

Vue.directive("trans", (el, binding) => {
  const language = store.getters.language;
  let value = binding.value[binding.arg + "_" + language];
  if (value) {
    return (el.innerHTML = value);
  } else {
    return (el.innerHTML = "");
  }
});

Vue.directive("currency", (el, binding) => {
  let currencyToBeFormatted = binding.value;

  try {
    el.innerHTML = new Intl.NumberFormat(
      store.getters.languageLocales[localStorage.getItem("language")].locale,
      {
        style: "currency",
        currency:
          store.getters.languageLocales[localStorage.getItem("language")]
            .currency,
      }
    )
      .formatToParts(currencyToBeFormatted)
      .map(({ type, value }) => {
        switch (type) {
          case "currency":
            return `${store.getters.currency}`;
          default:
            return value;
        }
      })
      .reduce((string, part) => string + part);
  } catch (e) {
    // custom implementation
    currencyToBeFormatted;
  }
});
